<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <v-list-item>
        <v-list-item-avatar
          class="align-self-center"
          contain
        >
          <v-img
            src="favicon.png"
            max-height="100%"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="text-h4"
            v-text="profile.title"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item
          v-if="access.includes(item.access)"
          :key="`item-${i}`"
          :item="item"
        />
      </template>
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  // rebuild
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState(['barColor', 'barImage', 'access', 'roles']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          title: this.$t('avatar'),
        }
      },
      items () {
        return [
          {
            icon: 'mdi-view-dashboard',
            title: 'dashboard',
            to: '/',
            access: this.roles.dashboard,
          },
          {
            icon: 'mdi-account',
            title: 'user',
            to: '/my-account',
            access: this.roles.myaccount,
          },
          {
            title: 'settings',
            icon: 'mdi-progress-wrench',
            to: '/settings',
            access: this.roles.settings,
          },
          {
            title: 'manager-forecast',
            icon: 'mdi-layers',
            to: '/manager-forecast',
            access: this.roles.mforecast,
          },
          {
            title: 'crew',
            icon: 'mdi-account-box-multiple',
            to: '/crew',
            access: this.roles.crewlist,
          },
          {
            title: 'scheduler',
            icon: 'mdi-calendar-multiple-check',
            to: '/scheduler',
            access: this.roles.scheduler,
          },
          {
            title: 'biometrics',
            icon: 'mdi-fingerprint',
            to: '/biometrics',
            access: this.roles.biometrics,
          },
          {
            title: 'schedules',
            icon: 'mdi-calendar-multiple-check',
            to: '/schedules',
            access: this.roles.schedules,
          },
          {
            title: 'reports',
            icon: 'mdi-chart-line-variant',
            to: '/reports',
            access: this.roles.reports,
          },
          {
            title: 'users',
            icon: 'mdi-account-key-outline',
            to: '/users',
            access: this.roles.users,
          },
          {
            title: 'stores',
            icon: 'mdi-sign-text',
            to: '/stores',
            access: this.roles.stores,
          },
        ]
      },
    },
    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
